// A list's quick filters change only their own parameters, keeping the search, the other filters and the view.
// Parameters are set or deleted in place, never appended again, so each stays in the URL once.

const filteredUrl = (change) => {
    const params = new URLSearchParams(window.location.search);
    // The live search doesn't reload the page, so the address bar may not have what is typed now. The page's own
    // search box: a modal can hold another one
    const searchBox = [...document.querySelectorAll('#searchQuery')].find((box) => !box.closest('.modal'));
    if (searchBox) {
        const search = searchBox.value.trim();
        if (search) {
            params.set('q', search);
        } else {
            params.delete('q');
        }
    }
    params.delete('page');
    change(params);
    const query = params.toString();
    return `${window.location.pathname}${query ? `?${query}` : ''}`;
};

const replaceParams = (params, entries) => {
    new Set(entries.map(([name]) => name)).forEach((name) => params.delete(name));
    entries.filter(([, value]) => value !== '').forEach(([name, value]) => params.append(name, value));
};

document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-filter-set], [data-filter-unset]');
    if (!link) return;
    event.preventDefault();
    window.location = filteredUrl((params) => {
        (link.dataset.filterUnset || '').split(' ').filter(Boolean).forEach((name) => params.delete(name));
        replaceParams(params, [...new URLSearchParams(link.dataset.filterSet || '').entries()]);
    });
});

// The live search swaps only the table, so the search box's × shows as soon as something is typed
document.addEventListener('input', (event) => {
    if (event.target.id !== 'searchQuery') return;
    const clearSearch = event.target.closest('#search-input')?.querySelector('#clear-search');
    if (clearSearch) clearSearch.hidden = !event.target.value.trim();
});

document.addEventListener('change', (event) => {
    const select = event.target.closest('select[data-filter-param]');
    if (!select) return;
    window.location = filteredUrl((params) => replaceParams(params, [[select.dataset.filterParam, select.value]]));
});

document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-filter-form]');
    if (!form) return;
    event.preventDefault();
    window.location = filteredUrl((params) => replaceParams(params, [...new FormData(form).entries()]));
});
